import { useCallback } from "react";
import { useLocation } from "react-router";
import { EventService } from "@perxis-auto/shared/lib";
import "../../../shared/config/env.js";
import { APP_EVENTS } from "../../../shared/config/events.js";
import { useConstructorContext } from "../../../shared/context/constructor.js";
import { useThisContext } from "../../../shared/context/this.js";
import { useMergedConstructorItemProps } from "../../../shared/lib/constructor/hooks/useMergedConstructorItemProps.js";
import "../../../shared/lib/constructor/mergeConstructor.js";
import "@perxis-auto/shared";
import "react/jsx-runtime";
import "@perxis-auto/ui-kit";
import { GET_DEFAULT_CONTAINER_PROPS } from "../config/props.js";
const useContainer = (item) => {
  const props = useMergedConstructorItemProps(item, GET_DEFAULT_CONTAINER_PROPS);
  const { layout, widgets } = useConstructorContext();
  const data = useThisContext();
  const { state } = useLocation();
  const handleClick = useCallback(
    (e) => {
      var _a;
      const target = e.target;
      if (!target.closest("[data-perxis-auto-stop-propagation]")) {
        EventService.getInstance().sendEvent(APP_EVENTS.CarTileSelected, {
          data,
          page: state == null ? void 0 : state.currentPage
        });
      }
      (_a = props == null ? void 0 : props.onClick) == null ? void 0 : _a.call(props, e);
    },
    [data, props, state]
  );
  return {
    ...props,
    layout,
    widgets,
    onClick: handleClick
  };
};
export {
  useContainer
};
